/**
 * Улучшенные сообщения для пользователя
 */

/**
 * Создаёт менеджер пользовательских сообщений
 */
export function createUserMessageManager({
  getTelegramWebApp,
  showLootboxNotification = null
}) {
  /**
   * Показывает понятное сообщение об ошибке
   * @param {string|Error} error - Ошибка или сообщение
   * @param {Object} options - Опции
   */
  function showError(error, options = {}) {
    const {
      title = '❌ Ошибка',
      fallback = 'Произошла ошибка. Попробуйте позже.'
    } = options;

    let message = fallback;

    if (typeof error === 'string') {
      message = error;
    } else if (error?.message) {
      message = translateErrorMessage(error.message);
    } else if (error?.error) {
      message = translateErrorCode(error.error);
    }

    const telegramWebApp = getTelegramWebApp();
    
    if (showLootboxNotification) {
      showLootboxNotification(title, message);
    } else if (telegramWebApp?.showAlert) {
      telegramWebApp.showAlert(`${title}\n\n${message}`);
    } else {
      alert(`${title}\n\n${message}`);
    }
  }

  /**
   * Показывает сообщение об успехе
   * @param {string} message - Сообщение
   * @param {string} title - Заголовок
   */
  function showSuccess(message, title = '✅ Успешно') {
    const telegramWebApp = getTelegramWebApp();
    
    if (showLootboxNotification) {
      showLootboxNotification(title, message);
    } else if (telegramWebApp?.showAlert) {
      telegramWebApp.showAlert(`${title}\n\n${message}`);
    } else {
      alert(`${title}\n\n${message}`);
    }
  }

  /**
   * Показывает информационное сообщение
   * @param {string} message - Сообщение
   * @param {string} title - Заголовок
   */
  function showInfo(message, title = 'ℹ️ Информация') {
    const telegramWebApp = getTelegramWebApp();
    
    if (showLootboxNotification) {
      showLootboxNotification(title, message);
    } else if (telegramWebApp?.showAlert) {
      telegramWebApp.showAlert(`${title}\n\n${message}`);
    } else {
      alert(`${title}\n\n${message}`);
    }
  }

  /**
   * Переводит технические сообщения об ошибках на понятный язык
   */
  function translateErrorMessage(message) {
    const translations = {
      'network error': 'Проблема с подключением к серверу. Проверьте интернет.',
      'failed to fetch': 'Не удалось подключиться к серверу. Проверьте интернет.',
      'timeout': 'Превышено время ожидания. Попробуйте позже.',
      'unauthorized': 'Требуется авторизация. Перезагрузите страницу.',
      'forbidden': 'Доступ запрещён.',
      'not found': 'Ресурс не найден.',
      'internal server error': 'Ошибка на сервере. Попробуйте позже.',
      'query read timeout': 'Операция заняла слишком много времени. Попробуйте ещё раз.',
      'insufficient': 'Недостаточно средств.',
      'already_has_premium': 'У вас уже есть активный премиум-пасс.',
      'creature_not_found': 'Существо не найдено.',
      'invalid': 'Некорректные данные.'
    };

    const lowerMessage = message.toLowerCase();
    
    for (const [key, translation] of Object.entries(translations)) {
      if (lowerMessage.includes(key)) {
        return translation;
      }
    }

    return message;
  }

  /**
   * Переводит коды ошибок на понятный язык
   */
  function translateErrorCode(errorCode) {
    const translations = {
      'network_error': 'Проблема с подключением к серверу',
      'timeout': 'Превышено время ожидания',
      'unauthorized': 'Требуется авторизация',
      'forbidden': 'Доступ запрещён',
      'not_found': 'Ресурс не найден',
      'server_error': 'Ошибка на сервере',
      'validation_error': 'Ошибка валидации данных',
      'insufficient_stars': 'Недостаточно звёзд',
      'insufficient_coins': 'Недостаточно монет',
      'insufficient_energy': 'Недостаточно энергии',
      'already_has_premium': 'У вас уже есть активный премиум-пасс',
      'creature_not_found': 'Существо не найдено',
      'invalid_data': 'Некорректные данные',
      'access_denied': 'Доступ ограничен'
    };

    return translations[errorCode] || errorCode;
  }

  return {
    showError,
    showSuccess,
    showInfo,
    translateErrorMessage,
    translateErrorCode
  };
}








